module.exports = __webpack_public_path__ + "a43573b65e47f9e814058b71bbc4aa5a.pdf";